import { render, staticRenderFns } from "./add-users-dialog.vue?vue&type=template&id=65428c84&"
import script from "./add-users-dialog.vue?vue&type=script&lang=js&"
export * from "./add-users-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports